import { Loan } from '@/types/nsldsTypes';
import { UserSurveyData } from '@/components/survey/user-survey';

export function useFinancialHardship(loans: Loan[], surveyData: UserSurveyData | null): boolean {
  if (!surveyData) return false;

  // Get total loan balance
  const totalLoanBalance = loans.reduce((sum, loan) => {
    return sum + Number(loan['Total Outstanding'] || 0);
  }, 0);

  // Get annual income
  const annualIncome = surveyData.annualIncome || 0;
  const partnerIncome = surveyData.includePartner ? surveyData.partnerAnnualIncome || 0 : 0;
  const totalAnnualIncome = annualIncome + partnerIncome;

  // Calculate monthly income
  const monthlyIncome = totalAnnualIncome / 12;

  // Calculate standard monthly payment (10-year standard repayment)
  const standardMonthlyPayment = (totalLoanBalance * 0.1) / 12;

  // Check if monthly payment exceeds 20% of monthly income
  const meetsFinancialHardship = standardMonthlyPayment > monthlyIncome * 0.2;

  return meetsFinancialHardship;
}
